import type { Bridge } from '../lib/api.js';

interface Props {
  bridges: Bridge[];
  wsStatus: 'connecting' | 'open' | 'closed';
}

export function BridgeIndicator({ bridges, wsStatus }: Props) {
  const anyConnected = bridges.some((b) => b.connected);
  const label = bridges.map((b) => `${b.label}: ${b.connected ? 'online' : 'offline'}`).join('\n');
  const color =
    anyConnected && wsStatus === 'open'
      ? 'var(--ac-success)'
      : wsStatus === 'connecting'
        ? 'var(--ac-warning)'
        : 'var(--ac-error)';
  const text =
    wsStatus === 'connecting' ? 'Connecting…' : anyConnected ? 'Bridge online' : 'Bridge offline';
  return (
    <div
      className="inline-flex items-center gap-2 text-sm"
      title={label || text}
      style={{ color: 'var(--ac-text-muted)' }}
    >
      <span
        className="inline-block w-2.5 h-2.5 rounded-full"
        style={{ backgroundColor: color }}
        aria-hidden="true"
      />
      <span>{text}</span>
    </div>
  );
}
